// src/hooks/useAppDispatch.js
import { useDispatch, useSelector } from 'react-redux'

// Dispatch hook
export const useAppDispatch = () => useDispatch()

// Selector hook (with proper argument forwarding)
export const useAppSelector = (selector) => useSelector(selector)

// Custom hook that returns both dispatch and selector-style use
export const useRedux = () => {
    const dispatch = useDispatch()
    const selector = (selFn) => useSelector(selFn)
    return { dispatch, selector }
}
